/* Símbolo · base (cabecera, menú, cesta, formularios). En Shopify: assets/simbolo-base.js */
(() => {
  const $ = (s, c = document) => c.querySelector(s), $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const eur = n => n.toLocaleString('es-ES', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €';

  /* ---- Navegación activa ---- */
  const page = document.body.dataset.page;
  $$(`[data-nav="${page}"]`).forEach(a => a.setAttribute('aria-current', 'page'));

  /* ---- Cabecera ---- */
  const cab = $('#simbolo-cabecera');
  addEventListener('scroll', () => cab.classList.toggle('is-scrolled', scrollY > 8), {passive: true});

  /* ---- Paneles (menú y cesta) ---- */
  const scrim = $('[data-scrim]');
  let abierto = null, origen = null;
  const focusables = el => $$('a[href],button:not([disabled]),input,textarea,select,[tabindex]:not([tabindex="-1"])', el).filter(x => x.offsetParent !== null);
  function open(id){
    const p = document.getElementById(id); if (!p) return;
    if (abierto && abierto !== p) close(false);
    origen = document.activeElement; abierto = p;
    p.classList.add('on'); p.setAttribute('aria-hidden', 'false');
    scrim.classList.add('on'); document.body.classList.add('locked');
    $$(`[data-open="${id}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
    requestAnimationFrame(() => (focusables(p)[0] || p).focus({preventScroll: true}));
  }
  function close(restore = true){
    if (!abierto) return;
    const id = abierto.id;
    abierto.classList.remove('on'); abierto.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('on'); document.body.classList.remove('locked');
    $$(`[data-open="${id}"]`).forEach(b => b.setAttribute('aria-expanded', 'false'));
    abierto = null;
    if (restore && origen) origen.focus({preventScroll: true});
  }
  /* Hoja de la cesta: arrastrar hacia abajo para cerrar (solo móvil), con resistencia hacia arriba */
  const cartEl = document.getElementById('cart');
  if (cartEl){
    let sy = null, dy = 0, t0 = 0;
    $$('[data-drag]', cartEl).forEach(h => {
      h.addEventListener('pointerdown', e => {
        if (e.target.closest('button') || matchMedia('(min-width: 900px)').matches) return;
        sy = e.clientY; dy = 0; t0 = performance.now(); cartEl.classList.add('dragging'); h.setPointerCapture(e.pointerId);
      });
      h.addEventListener('pointermove', e => {
        if (sy === null) return;
        dy = e.clientY - sy;
        cartEl.style.transform = `translateY(${dy < 0 ? dy * 0.2 : dy}px)`;
      });
      const end = () => {
        if (sy === null) return;
        const v = dy / Math.max(1, performance.now() - t0);
        cartEl.classList.remove('dragging'); cartEl.style.transform = '';
        if (dy > 110 || v > 0.5) close();
        sy = null;
      };
      h.addEventListener('pointerup', end); h.addEventListener('pointercancel', end);
    });
  }
  $$('[data-open]').forEach(b => b.addEventListener('click', () => open(b.dataset.open)));
  $$('[data-close]').forEach(b => b.addEventListener('click', () => close()));
  scrim.addEventListener('click', () => close());
  addEventListener('keydown', e => {
    if (!abierto) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab'){
      const f = focusables(abierto); if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    }
  });

  /* ---- Cesta: API AJAX de Shopify (/cart.js, /cart/add.js, /cart/change.js) ---- */
  const CFG = window.SBL || {};
  const FREE = CFG.free || 29;
  const money = c => (c / 100).toLocaleString('es-ES', {style: 'currency', currency: 'EUR'});
  const body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
  const badge = $('#cesta .n');
  const api = (url, data) => fetch(url, data ? {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(data)} : {headers: {Accept: 'application/json'}}).then(r => r.json());

  const MAX = 24;   // tope por pedido en la web (más, por Profesionales)
  let units = 0;
  const TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M5 7h14M10 11v6M14 11v6M7 7l1 12h8l1-12M9.5 7V4.5h5V7"/></svg>';
  function upsell(u){
    const P = PK(); if (!u) return '';
    if (u < 3) return `<div class="upsell"><p><b>Completa el Pack 3</b>Añade ${3 - u} y te sale a ${eur(P[3].price / 3)} la botella, con envío gratis.</p><button class="btn" type="button" data-set="3">Pack 3</button></div>`;
    if (u < 12) return `<div class="upsell"><p><b>¿Regalas? Pásate al Pack 12</b>12 botellas a ${eur(P[12].price / 12)} cada una.</p><button class="btn" type="button" data-set="12">Pack 12</button></div>`;
    return '';
  }
  /* Los packs se cuentan como packs: 3 botellas = «Pack 3 × 1». En Shopify es una sola línea con cantidad en botellas
     (el stock resta botellas y los descuentos automáticos fijan el precio); aquí se descompone en 12 + 3 + sueltas. */
  const DEF = {1: {price: 10.9, compare: 12.9}, 3: {price: 29.9, compare: 34.9}, 12: {price: 99, compare: 129.9}};
  const PK = () => CFG.packs || DEF;
  const ours = it => it.variant_id === CFG.variant || it.handle === 'simbolo-aove-picual_250';
  /* Igual que los descuentos: desde 12 botellas todas van a precio Pack 12 (las que sobran, «botellas extra» a 8,25 €) */
  const partes = q => (q >= 12 ? [[12, Math.floor(q / 12)], ['x', q % 12]] : [[3, Math.floor(q / 3)], [1, q % 3]]).filter(p => p[1] > 0);
  function render(c){
    const t = c.total_price;
    units = 0; let piezas = 0;
    c.items.forEach(it => { if (ours(it)){ units += it.quantity; piezas += partes(it.quantity).reduce((a, p) => a + p[1], 0); } else piezas += it.quantity; });
    badge.textContent = piezas; badge.classList.toggle('on', piezas > 0);
    $('#cesta').setAttribute('aria-label', piezas ? `Cesta, ${piezas} ${piezas === 1 ? 'artículo' : 'artículos'}` : 'Cesta, vacía');
    if (!c.item_count){
      body.innerHTML = `<div class="vacia"><p>Tu cesta está vacía.</p><a class="btn" href="/#hero-buy">Ver la Edición cero</a></div>`;
      foot.hidden = true; return;
    }
    foot.hidden = false;
    const falta = FREE * 100 - t;
    let html = `<div class="envio-bar"><p>${falta > 0 ? `Te faltan <b class="tnum">${money(falta)}</b> para el envío gratis.` : '<b>Tienes envío gratis.</b> Llega en 3–5 días laborables.'}</p><div class="track"><i style="transform:scaleX(${Math.min(1, t / (FREE * 100))})"></i></div></div>`;
    c.items.forEach(it => {
      const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      const th = `<div class="th">${img ? `<img src="${img}" alt="">` : ''}</div>`;
      if (ours(it)){
        const q = it.quantity, P = PK();
        partes(q).forEach(([k, n]) => {
          const extra = k === 'x', size = extra ? 1 : k;
          const nombre = extra ? 'Botella extra' : size === 1 ? 'Botella suelta' : `Pack ${size}`;
          const detalle = extra ? `A precio Pack 12 · ${eur(P[12].price / 12)}/ud` : size === 1 ? `${eur(P[1].price)} la botella · envío aparte` : `${size} botellas · ${eur(P[size].price / size)}/ud`;
          const precio = Math.round((extra ? P[12].price / 12 : P[size].price) * n * 100), antes = Math.round((extra ? P[1].compare : P[size].compare) * n * 100);
          const lleno = units + size > MAX;
          html += `<div class="linea">${th}<div><h3>${nombre} <span class="meta-n">· Edición cero</span></h3><p class="meta">${detalle}</p><div class="linea-acc"><div class="qty" role="group" aria-label="${nombre}: cantidad"><button type="button" data-set-q="${it.key}" data-q="${q - size}" aria-label="${n > 1 ? `Un ${nombre.toLowerCase()} menos` : `Quitar ${nombre.toLowerCase()}`}">${n > 1 ? '−' : TRASH}</button><span class="tnum" aria-live="polite">${n}</span><button type="button" data-set-q="${it.key}" data-q="${q + size}" aria-label="Un ${nombre.toLowerCase()} más"${lleno ? ' disabled' : ''}>+</button></div></div></div><p class="pr tnum">${money(precio)}${antes > precio ? `<s>${money(antes)}</s>` : ''}</p></div>`;
        });
      } else {
        const q = it.quantity;
        html += `<div class="linea">${th}<div><h3>${it.product_title}</h3><p class="meta">${money(Math.round(it.final_line_price / q))}/ud</p><div class="linea-acc"><div class="qty" role="group" aria-label="Cantidad"><button type="button" data-set-q="${it.key}" data-q="${q - 1}" aria-label="${q > 1 ? 'Una menos' : 'Quitar'}">${q > 1 ? '−' : TRASH}</button><span class="tnum" aria-live="polite">${q}</span><button type="button" data-set-q="${it.key}" data-q="${q + 1}" aria-label="Una más">+</button></div></div></div><p class="pr tnum">${money(it.final_line_price)}</p></div>`;
      }
    });
    if (units >= MAX) html += `<p class="tope">Desde la web, hasta ${MAX} botellas. ¿Necesitas más? <a class="link" href="/pages/simbolo-aove-para-profesionales">Escríbenos</a>.</p>`;
    html += upsell(units);
    body.innerHTML = html;
    $('[data-cart-total]').textContent = money(t);
  }
  const refresh = () => api('/cart.js').then(render);
  let busy = false;
  const change = (key, quantity) => { if (busy) return; busy = true; body.classList.add('is-busy'); api('/cart/change.js', {id: key, quantity}).then(refresh).finally(() => { busy = false; body.classList.remove('is-busy'); }); };
  body.addEventListener('click', e => {
    const sq = e.target.closest('[data-set-q]'), s = e.target.closest('[data-set]');
    if (sq && !sq.disabled) change(sq.dataset.setQ, Math.max(0, +sq.dataset.q));
    if (s && CFG.variant){
      const want = +s.dataset.set;
      api('/cart.js').then(c => {
        const line = c.items.find(i => i.variant_id === CFG.variant);
        return line ? api('/cart/change.js', {id: line.key, quantity: want}) : api('/cart/add.js', {items: [{id: CFG.variant, quantity: want}]});
      }).then(refresh);
    }
  });

  window.SimboloCart = {
    add(pack){
      if (!CFG.variant) return Promise.resolve();
      if (units + pack > MAX){ open('cart'); return refresh(); }
      return api('/cart/add.js', {items: [{id: CFG.variant, quantity: pack}]}).then(r => {
        if (r.status && r.status >= 400){ alertBox(r.description || 'No hemos podido añadirlo.'); return refresh(); }
        return refresh().then(() => { badge.classList.remove('bump'); void badge.offsetWidth; badge.classList.add('bump'); open('cart'); });
      });
    },
    PACKS: CFG.packs, FREE, eur
  };
  function alertBox(msg){ const p = document.createElement('p'); p.className = 'form-error'; p.setAttribute('role', 'alert'); p.textContent = msg; body.prepend(p); open('cart'); }
  refresh();

  /* ---- Email: validación en línea, en español y junto al campo (sustituye al globo del navegador) ---- */
  $$('input[type=email][aria-describedby]').forEach(inp => {
    const f = inp.form, err = document.getElementById(inp.getAttribute('aria-describedby'));
    if (!f || !err) return;
    f.noValidate = true;
    const clear = () => { inp.removeAttribute('aria-invalid'); err.textContent = ''; };
    inp.addEventListener('input', clear);
    f.addEventListener('submit', e => {
      if (inp.checkValidity()) return clear();
      e.preventDefault(); e.stopImmediatePropagation();
      inp.setAttribute('aria-invalid', 'true');
      err.textContent = inp.value.trim() ? 'Revisa el email: debería ser algo como tu@email.com.' : 'Escribe tu email para apuntarte.';
      inp.focus();
    });
  });

  /* ---- Formularios nativos de Shopify: estado «Enviando…» ---- */
  $$('form.em-form, .agotado form').forEach(f => f.addEventListener('submit', () => {
    const b = $('button[type=submit]', f); if (b){ setTimeout(() => { b.disabled = true; b.textContent = 'Enviando…'; }, 0); }
  }));
})();

/* Preferencias de cookies: en Shopify abre el banner de privacidad nativo */
document.querySelectorAll('[data-cookies]').forEach(b => b.addEventListener('click', () => { if (window.privacyBanner && privacyBanner.showPreferences) privacyBanner.showPreferences(); }));

if (document.getElementById('simbolo-hero')) /* Símbolo · ficha de producto. En Shopify: assets/simbolo-producto.js */
(() => {
  const $ = (s, c = document) => c.querySelector(s), $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const {PACKS, FREE, eur} = window.SimboloCart;
  const TOTAL = (window.SBL && SBL.total) || 300, BAR_FROM = 150, LOW = 20;
  const qs = new URLSearchParams(location.search);
  const CFG = window.SBL || {};
  const S = {stock: qs.has('stock') ? Math.max(0, +qs.get('stock')) : (CFG.stock ?? 300), pack: 3};
  const O = k => $$(`[data-o="${k}"]`);
  const hero = $('#simbolo-hero'), seg = $('.seg'), ind = $('.seg .ind'), radios = $$('.seg [role=radio]');

  function setText(k, v, html){
    O(k).forEach(el => {
      const val = String(v);
      if ((html ? el.innerHTML : el.textContent) === val) return;
      if (el.classList.contains('swap')){ el.classList.add('out'); setTimeout(() => { html ? el.innerHTML = val : el.textContent = val; el.classList.remove('out'); }, 120); }
      else html ? el.innerHTML = val : el.textContent = val;
    });
  }

  /* ---------- Galería: cada pack enseña su selección de fotos (data-packs en cada foto) ---------- */
  const track = $('#gal-track'), slides = $$('.slide', track), dots = $('.gal-dots'), thumbs = $$('.gal-thumbs button');
  let gvis = slides, dotBtns = [], cur = 0;
  const go = (i, now) => { if (!gvis.length) return; i = Math.max(0, Math.min(gvis.length - 1, i)); track.scrollTo({left: gvis[i].offsetLeft - track.offsetLeft, behavior: now || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); };
  function mark(i){
    if (i < 0) return; cur = i;
    dotBtns.forEach((b, j) => b.setAttribute('aria-current', j === i));
    thumbs.forEach(b => b.setAttribute('aria-current', gvis.indexOf(slides[thumbs.indexOf(b)]) === i));
    $('.gal-flecha.prev').disabled = i === 0; $('.gal-flecha.next').disabled = i === gvis.length - 1;
  }
  function galPack(pack){
    slides.forEach((s, k) => {
      const on = !s.dataset.packs || s.dataset.packs.split(',').includes(String(pack));
      s.hidden = !on; if (thumbs[k]) thumbs[k].hidden = !on;
    });
    gvis = slides.filter(s => !s.hidden);
    gvis.forEach((s, i) => s.setAttribute('aria-label', `${i + 1} de ${gvis.length}`));
    dots.textContent = '';
    dotBtns = gvis.map((_, i) => { const b = document.createElement('button'); b.type = 'button'; b.tabIndex = -1; b.addEventListener('click', () => go(i)); dots.appendChild(b); return b; });
    track.scrollLeft = 0; mark(0);
  }
  const gio = new IntersectionObserver(es => es.forEach(e => { if (e.intersectionRatio > .6) mark(gvis.indexOf(e.target)); }), {root: track, threshold: [.6]});
  slides.forEach(s => gio.observe(s));
  thumbs.forEach((b, k) => b.addEventListener('click', () => go(gvis.indexOf(slides[k]))));
  $$('[data-gal]').forEach(b => b.addEventListener('click', () => go(cur + +b.dataset.gal)));
  track.addEventListener('keydown', e => { if (e.key === 'ArrowRight'){ e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft'){ e.preventDefault(); go(cur - 1); } });
  galPack(S.pack || 3);

  /* ---------- Foto del pack: la primera de la galería cambia con la selección ---------- */
  const PIMG = CFG.img || {};
  const gp = $('#gal-pack'), tp = $('#thumb-pack');
  let shown = 3, preloaded = false;
  function packImg(pack){
    if (pack === shown) return; shown = pack;
    const d = PIMG[pack], pre = new Image();
    pre.src = matchMedia('(min-width:900px)').matches || devicePixelRatio > 1.5 ? d.l : d.s;
    gp.classList.add('out');
    const swap = () => { gp.srcset = `${d.s} 800w, ${d.l} 1600w`; gp.src = d.s; gp.alt = d.alt; tp.src = d.s; requestAnimationFrame(() => gp.classList.remove('out')); };
    (pre.decode ? pre.decode() : Promise.resolve()).then(swap, swap);
    galPack(pack);
    /* las demás fotos cambian con el pack: un fundido corto evita el salto */
    [$('.gal-thumbs'), dots].forEach(el => el && el.animate && el.animate([{opacity: .35}, {opacity: 1}], {duration: 220, easing: 'cubic-bezier(0.23, 1, 0.32, 1)'}));
  }
  const preload = () => { if (preloaded) return; preloaded = true; Object.values(PIMG).forEach(d => { new Image().src = d.s; }); };
  seg.addEventListener('pointerenter', preload); seg.addEventListener('focusin', preload); setTimeout(preload, 3000);

  /* ---------- Precio, packs y stock ---------- */
  function render(){
    const soldout = S.stock <= 0;
    hero.classList.toggle('is-soldout', soldout);
    document.documentElement.classList.toggle('soldout', soldout);
    radios.forEach(r => {
      const u = +r.dataset.pack, off = u > S.stock;
      r.setAttribute('aria-disabled', off);
      $('.pd', r).textContent = off ? 'No quedan' : (u === 1 ? eur(PACKS[1].price) : eur(PACKS[u].price / u) + '/ud');
    });
    $$('.tabla li').forEach(li => { const off = +li.dataset.row > S.stock; li.setAttribute('aria-disabled', off); $('button', li).disabled = off; });
    if (!soldout && S.pack > S.stock) S.pack = [12, 3, 1].find(u => u <= S.stock) || 1;
    const p = PACKS[S.pack], i = [1, 3, 12].indexOf(S.pack);
    radios.forEach(r => { const on = +r.dataset.pack === S.pack; r.setAttribute('aria-checked', on); r.tabIndex = on ? 0 : -1; });
    ind.style.transform = `translateX(${i * 100}%)`;
    packImg(S.pack);

    const ahorro = p.compare - p.price;
    setText('total', eur(p.price));
    setText('compare', eur(p.compare));
    setText('ahorro', ahorro > 0 ? 'Ahorras ' + eur(ahorro) : '');
    O('compare').forEach(el => el.hidden = ahorro <= 0); O('ahorro').forEach(el => el.hidden = ahorro <= 0);
    setText('cta', eur(p.price));
    setText('envio', p.price >= FREE ? 'Envío gratis en este pedido' : 'Envío gratis en packs');

    const pill = $('#stock-pill'), bar = $('#stock-bar');
    pill.classList.toggle('low', S.stock <= LOW);
    setText('stock', 'Últimas unidades');
    bar.hidden = true;
    O('bar').forEach(el => el.style.transform = `scaleX(${S.stock / TOTAL})`);
    setText('bar-t', `${p.name} · ${eur(p.price)}`);
    setText('bar-s', 'Últimas unidades');
    updateBar();
  }
  radios.forEach(r => r.addEventListener('click', () => { if (r.getAttribute('aria-disabled') === 'true') return; S.pack = +r.dataset.pack; render(); }));
  seg.addEventListener('keydown', e => {
    if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
    e.preventDefault();
    const order = [1, 3, 12].filter(u => u <= S.stock), d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
    S.pack = order[(order.indexOf(S.pack) + d + order.length) % order.length]; render(); $(`[data-pack="${S.pack}"]`, seg).focus();
  });
  /* «Comprar» en Precio de cierre y en Lo que te llevas: mete el pack en la cesta y va directo al pago */
  $$('[data-pick]').forEach(b => b.addEventListener('click', () => {
    S.pack = +b.dataset.pick; render();
    if (S.stock <= 0 || b.disabled) return;
    const label = b.innerHTML;
    b.style.width = b.offsetWidth + 'px'; b.disabled = true; b.setAttribute('aria-busy', 'true');
    b.innerHTML = '<span class="spin" aria-hidden="true"></span><span class="sr">Un momento…</span>';
    const done = () => { b.innerHTML = label; b.style.width = ''; b.disabled = false; b.removeAttribute('aria-busy'); };
    Promise.resolve(window.SimboloCart.add(S.pack)).then(() => { if (window.SBL) location.href = '/checkout'; })
      .finally(() => setTimeout(done, window.SBL ? 4000 : 700));
    addEventListener('pageshow', done, {once: true});
  }));

  /* ---------- Añadir ---------- */
  const cta = $('#cta'); let t;
  function add(){
    if (S.stock <= 0) return;
    window.SimboloCart.add(S.pack);
    cta.classList.add('added'); clearTimeout(t); t = setTimeout(() => cta.classList.remove('added'), 1600);
  }
  cta.addEventListener('click', add);
  $('[data-add]').addEventListener('click', add);
  $('[data-goto=hero]').addEventListener('click', () => $('#hero-buy').scrollIntoView({block: 'center'}));

  /* ---------- Barra fija ---------- */
  const barra = $('#simbolo-barra'), vis = {cta: true, end: false};
  function updateBar(){ const on = !vis.cta && !vis.end && S.stock > 0; barra.classList.toggle('on', on); barra.setAttribute('aria-hidden', !on); document.documentElement.classList.toggle('sbl-barra-on', on); }
  new IntersectionObserver(([e]) => { vis.cta = e.isIntersecting; updateBar(); }).observe(cta);
  const ends = new Set();   /* secciones del final visibles ahora (el observador solo avisa de las que cambian) */
  const endIO = new IntersectionObserver(es => { es.forEach(e => e.isIntersecting ? ends.add(e.target) : ends.delete(e.target)); vis.end = ends.size > 0; updateBar(); });
  ['#simbolo-hablamos', '#simbolo-email', '#simbolo-footer'].forEach(s => { const el = $(s); if (el) endIO.observe(el); });

  /* ---------- Reseñas: avanzan solas, se paran al tocarlas ---------- */
  const rt = $('#res-track');
  if (rt) {
  const cards = $$('.res-card', rt); cards.forEach(c => { const k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); rt.appendChild(k); });
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false, resumeT, raf, last = 0, visible = false, acc = 0;
  const half = () => rt.scrollWidth / 2;
  function tick(ts){
    if (!last) last = ts;
    const dt = Math.min(64, ts - last); last = ts;
    if (!paused && visible && !reduce.matches){
      acc += dt * 0.035;               // ~35 px/s
      if (acc >= 1){ const px = Math.floor(acc); acc -= px; rt.scrollLeft += px; if (rt.scrollLeft >= half()) rt.scrollLeft -= half(); }
    }
    raf = requestAnimationFrame(tick);
  }
  let userStop = false;
  const pause = () => { paused = true; clearTimeout(resumeT); };
  const resume = (ms = 2500) => { if (userStop) return; clearTimeout(resumeT); resumeT = setTimeout(() => { paused = false; }, ms); };
  const pb = $('#res-pausa');
  if (reduce.matches) pb.hidden = true;
  pb.addEventListener('click', () => {
    userStop = !userStop; paused = userStop;
    pb.setAttribute('aria-pressed', userStop); pb.querySelector('span').textContent = userStop ? 'Reanudar' : 'Pausar';
  });
  /* cita grande: rota con el carrusel y se para con él */
  const lq = $$('#lead-rot .lead-q'), la = $$('#lead-a span');
  let li = 0, lt = 0;
  const show = i => { [lq, la].forEach(g => g.forEach((el, k) => { el.classList.toggle('on', k === i); el.setAttribute('aria-hidden', k === i ? 'false' : 'true'); })); };
  setInterval(() => {
    if (paused || !visible || reduce.matches) return;
    if (++lt < 6) return; lt = 0;      // cada ~6 s
    li = (li + 1) % lq.length; show(li);
  }, 1000);
  rt.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') pause(); });
  rt.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') resume(400); });
  rt.addEventListener('pointerdown', pause);
  rt.addEventListener('pointerup', () => resume());
  rt.addEventListener('touchend', () => resume(), {passive: true});
  rt.addEventListener('focusin', pause); rt.addEventListener('focusout', () => resume());
  rt.addEventListener('scroll', () => { if (rt.scrollLeft >= half()) rt.scrollLeft -= half(); }, {passive: true});
  /* arrastre con ratón (en táctil ya es nativo) */
  let dragX = null, startLeft = 0;
  rt.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; dragX = e.clientX; startLeft = rt.scrollLeft; rt.classList.add('drag'); rt.setPointerCapture(e.pointerId); });
  rt.addEventListener('pointermove', e => { if (dragX === null) return; rt.scrollLeft = startLeft - (e.clientX - dragX); });
  rt.addEventListener('pointerup', () => { dragX = null; rt.classList.remove('drag'); });
  new IntersectionObserver(([e]) => { visible = e.isIntersecting; }).observe(rt);
  document.addEventListener('visibilitychange', () => { last = 0; });
  raf = requestAnimationFrame(tick);
  }


  /* Tabla de packs con los mismos precios de la ficha */
  $$('.tabla li').forEach(li => {
    const p = PACKS[+li.dataset.row], cell = $('.p', li); if (!p || !cell) return;
    cell.innerHTML = eur(p.price) + (p.compare > p.price ? '<s>' + eur(p.compare) + '</s>' : '');
  });
  /* Tabla de cierre con los mismos precios de la ficha */
  $$('.tabla li').forEach(li => {
    const p = PACKS[+li.dataset.row]; if (!p) return;
    const cell = $('.p', li); if (cell) cell.innerHTML = eur(p.price) + '<s>' + eur(p.compare) + '</s>';
  });
  render();
})();
/* Símbolo · páginas interiores. En Shopify: assets/simbolo-paginas.js */
(() => {
  const $ = (s, c = document) => c.querySelector(s), $$ = (s, c = document) => [...c.querySelectorAll(s)];

  /* ---- Formularios con validación en línea (en Shopify: form 'contact') ---- */
  $$('form.sbl-contact').forEach(f => {
    const check = el => {
      const ok = el.checkValidity();
      el.setAttribute('aria-invalid', !ok);
      el.style.borderColor = ok ? '' : '#C2522C';
      return ok;
    };
    $$('input[required],textarea[required]', f).forEach(el => el.addEventListener('blur', () => check(el)));
    f.addEventListener('submit', e => {
      const bad = $$('input[required],textarea[required]', f).filter(el => !check(el));
      if (bad.length){ e.preventDefault(); bad[0].focus(); return; }
      const b = $('button[type=submit]', f); setTimeout(() => { b.disabled = true; b.textContent = 'Enviando…'; }, 0);
    });
  });

  /* ---- FAQ: búsqueda y temas ---- */
  const q = $('#faq-q');
  if (q){
    const items = $$('#faq-list details'), groups = $$('.faq-grupo'), none = $('#sin-res');
    const norm = s => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    q.addEventListener('input', () => {
      const v = norm(q.value.trim()); let n = 0;
      items.forEach(d => { const hit = !v || norm(d.textContent).includes(v); d.hidden = !hit; if (hit) n++; if (v && hit) d.open = true; });
      groups.forEach(g => g.hidden = !$$('details', g).some(d => !d.hidden));
      none.style.display = n ? 'none' : 'block';
    });
    const links = $$('.faq-nav a');
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting){ links.forEach(a => a.classList.toggle('on', a.hash === '#' + e.target.id)); const on = links.find(a => a.classList.contains('on')), nav = $('.faq-nav .chips'); if (on) nav.scrollTo({left: on.offsetLeft - nav.clientWidth / 2 + on.clientWidth / 2, behavior: 'smooth'}); }
    }), {rootMargin: '-45% 0px -50% 0px'});
    groups.forEach(g => io.observe(g));
  }
})();
